import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../../Dashboard/Header";
import Button from "@mui/material/Button";
import VerifiedIcon from "@mui/icons-material/Verified";
import Swal from "sweetalert2";
import ShowLedDetails from "./ShowLedDetails";
const PREFERENCE_KEY = "infiniteAppUserPreferences";

//Local Variables
export default function LedPrimaryApproval() {
  const [PriLed, setPriLed] = useState([]);
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");
  const [selectedIds, setSelectedIds] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [pageSize, setPageSize] = useState(20);

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  //call after Component load
  useEffect(() => {
    fetchData();
  }, [token, cmpid]);

  //fuction to fetch Primary Approval Ledger list
  const fetchData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/approvalModule/ledPrimaryList",
        { cmpid },
        {
          headers: { Authorization: token },
        }
      );
      const arrayData = Object.values(response.data);
      // console.log(arrayData);
      setPriLed(arrayData);
    } catch (error) {
      console.log(error);
    }
  };

  /* ───────── fetch Group ───────── */

  const fetchGroupList = async (LedGrp) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/display/group`,
        { cmpid },
        { headers: { Authorization: token } }
      );

      const GroupList = response.data.groupMap[0].group;
      const selectedConfigs = GroupList.filter(
        (grp) => grp.groupName === LedGrp.led_Parent
      );

      // console.log("Matched Groups:", selectedConfigs[0].approvalConfig[0]);

      return selectedConfigs[0].approvalConfig[0];
    } catch (err) {
      console.error("Error fetching group data:", err);
      return null;
    }
  };

  //___________________approval function for single Voucher ___________________

  const handleApproval = async (rowData) => {
    try {
      const result = await fetchGroupList(rowData);
      // console.log("result data", result);

      const singleApp = {
        ledLevel: result?.level,
        ledid: rowData.id,
      };

      // console.log("1 Approve body", singleApp);

      await axios.post(
        `${process.env.REACT_APP_API_URL}/approvalModule/ledPrimaryUpdate`,
        singleApp,
        {
          headers: { Authorization: token },
        }
      );
      // Success Alert
      Swal.fire({
        title: "Approved!",
        text: "Approved successfully.",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#28a745",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },

        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
      fetchData();
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      });
    }
  };

  //function for bulk approval
  const handleApprovalAll = () => {
    const selectedVoucherIds = rows
      .filter((row) => selectedIds.includes(row.id))
      .map((row) => row.id);

    const formattedArray = selectedVoucherIds.map((id) => ({
      ledid: id,
    }));

    if (formattedArray.length === 0) {
      Swal.fire({
        title: "Warning",
        text: "Please select check box for Multiple Approval.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#f0ad4e",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      });
      return;
    }

    try {
      axios.post(
        `${process.env.REACT_APP_API_URL}/approvalModule/allLedPrimaryUpdate`,
        formattedArray,
        {
          headers: { Authorization: token },
        }
      );
      // Success Alert
      Swal.fire({
        title: "Approved!",
        text: "Approved successfully.",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#28a745",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },

        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
      fetchData();
    } catch (error) {
      //error alert
      Swal.fire({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      });
    }
  };

  //rows for vouchers table
  const rows = Array.isArray(PriLed)
    ? PriLed.map((Priled) => ({
        id: Priled.led_Id,
        led_Name: Priled.led_Name,
        led_Parent: Priled.led_Parent,
        led_Address: Priled.led_Address,
        led_State: Priled.led_State,
        led_Country: Priled.led_Country,
        led_Pincode: Priled.led_Pincode,
        led_GSTIN: Priled.led_GSTIN,
        led_GSTReg: Priled.led_GSTReg,
        led_Pan: Priled.led_Pan,
        reject_Remark: Priled.reject_Remark,
      }))
    : [];

  //colums for primary Ledger table

  const getColumnWidth = (rows, field, header) => {
    const maxLength = Math.max(
      ...rows.map((r) => (r[field] ? r[field].toString().length : 0)),
      header.length
    );
    return maxLength * 10 + 15;
  };
  const columns = [
    {
      field: "led_Name",
      headerName: "Name",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "led_Name", "Name"),
    },

    {
      field: "led_Parent",
      headerName: "Parent",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "led_Parent", "Parent"),
    },
    {
      field: "led_Address",
      headerName: "Address",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "led_Address", "Address"),
    },
    {
      field: "led_State",
      headerName: "State",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "led_State", "State"),
    },
    {
      field: "led_Country",
      headerName: "Country",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "led_Country", "Country"),
    },
    {
      field: "led_Pan",
      headerName: "PAN/IT No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "led_Pan", "PAN/IT No"),
    },

    {
      field: "led_GSTReg",
      headerName: "Registration Type",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "led_GSTReg", "Registration Type"),
    },
    {
      field: "led_GSTIN",
      headerName: "GSTIN No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "led_GSTIN", "GSTIN No"),
    },

    {
      field: "reject_Remark",
      headerName: "Remark",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "reject_Remark", "Remark"),
    },
    {
      field: "Action",
      headerName: "",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      headerClassName: "sticky-col-header",
      cellClassName: "sticky-col",
      width: 150,
      renderCell: (PriVch) => (
        <Box>
          <Button
            variant="contained"
            color="success"
            startIcon={<VerifiedIcon />}
            type="button"
            style={{ height: 20, fontSize: 15 }}
            onClick={(e) => {
              e.stopPropagation();
              // setrowData(PriVch.row);
              handleApproval(PriVch.row);
            }}
          >
            Approve
          </Button>
        </Box>
      ),
    },
  ];

  // code for single ledger data show
  const [open, setOpen] = useState(false);
  const [ledId, setledId] = useState("");

  const handleClose = () => setOpen(false);

  const handleShowData = async (id) => {
    setOpen(true);
    setledId(id);
  };

  return (
    <>
      <ShowLedDetails open={open} ledId={ledId} handleClose={handleClose} />

      {/* //button for selected Approval */}
      <Box mt="70px" ml="0px" mr="20px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header title="Ledger Approval" subtitle="Primary Ledger Approval" />
          <Button
            variant="contained"
            color="success"
            sx={{
              height: "30px",
              minHeight: "30px",
            }}
            onClick={handleApprovalAll}
          >
            Approve All
          </Button>
        </Box>

        <Box
          height="80vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
              cursor: "pointer",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              color: colors.primary[150],
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },
            "& .MuiDataGrid-cell:focus": { outline: "none" },
            // ✅ Add horizontal grid lines
            "& .MuiDataGrid-row": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            // ✅ Zoom on hover using a class
            "& .PriLzoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
            // ✅ Sticky column styles
            "& .sticky-col-header": {
              position: "sticky",
              right: 0,
              zIndex: 2,
              backgroundColor: colors.blueAccent[700],
            },
            "& .sticky-col": {
              position: "sticky",
              right: 0,
              zIndex: 1,
              backgroundColor: colors.primary[400],
            },
            "& .PriLzoom-row:hover .sticky-col": {
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            onRowClick={(params) => handleShowData(params.row.id)}
            getRowClassName={() => "PriLzoom-row"}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            rowHeight={30}
            headerHeight={30}
            componentsProps={{
              footer: {
                sx: {
                  height: 30,
                  minHeight: 30,
                },
              },
            }}
            checkboxSelection
            onSelectionModelChange={(newSelection) =>
              setSelectedIds(newSelection)
            }
            sx={{
              "& .MuiDataGrid-virtualScroller": {
                overflow: "auto",
              },
            }}
          />
        </Box>
      </Box>
    </>
  );
}